import React, { useEffect } from 'react';

const SalesCommission = () => {
  useEffect(() => {
    window.location.href = '/sales-commission.html';
  }, []);

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <p>Redirecting to Sales Commission Calculator...</p>
    </div>
  );
};

export default SalesCommission;
